/**
 * AI.GEN lines=1-120
 * 统一枚举定义文件
 * 所有枚举都定义在此文件中，便于统一管理
 */

// ========== 用户权限相关 ==========

/**
 * 用户权限类型枚举
 * - Enabled: 已启用（有权限）
 * - Disabled: 已禁用（无权限）
 */
export enum UserPermissionType {
  /** 已禁用（无权限） */
  Disabled = 0,
  /** 已启用（有权限） */
  Enabled = 1,
}

// ========== 国家相关 ==========

/**
 * 国家代码类型
 */
export type ICountryCode =
  | 'CN'
  | 'NZ'
  | 'EUR'
  | 'US'
  | 'AU'
  | 'CA'
  | 'JP'
  | 'SG'
  | 'KR'
  | 'GB';

/**
 * 国家 token 名
 */
export const tokenNameEnum: Record<string, string> = {
  NZ: 'NZD_token',
  EUR: 'EUR_token',
  US: 'USA_token',
  AU: 'AUS_token',
  CA: 'CA_token',
  JP: 'JP_token',
  KR: 'KR_token',
  SG: 'SG_token',
  GB: 'UK_token',
};

/**
 * 域名枚举
 */
export const domainEnum: Record<string, string> = {
  release: '.hungrypanda.co',
  beta: '.hungrypanda.it',
  dev: '.hungrypanda.cn',
  test: '.hungrypanda.cn',
};

/**
 * 时区枚举（与old项目保持一致）
 */
export const timezonesEnum: Record<ICountryCode, string> = {
  CN: 'Asia/Shanghai',
  GB: 'Europe/London',
  EUR: 'Europe/Paris',
  NZ: 'Pacific/Auckland',
  AU: 'Australia/Melbourne',
  US: 'America/New_York',
  CA: 'America/Toronto',
  KR: 'Asia/Seoul',
  JP: 'Asia/Tokyo',
  SG: 'Asia/Hong_Kong',
};

/**
 * 跳转其他国家地址（与old项目保持一致）
 */
export const countryUrlEnum: Record<string, string> = {
  NZ: 'https://dispatch-nzd.hungrypanda.co',
  EUR: 'https://dispatch-eur.hungrypanda.co',
  US: 'https://dispatch-us.hungrypanda.co',
  AU: 'https://dispatch-aus.hungrypanda.co',
  CA: 'https://dispatch-ca.hungrypanda.co',
  JP: 'https://dispatch-jp.hungrypanda.co',
  KR: 'https://dispatch-kr.hungrypanda.co',
  SG: 'https://dispatch-sg.hungrypanda.co',
  GB: 'https://dispatch-uk.hungrypanda.co',
};

// ========== 订单业务相关 ==========

/**
 * 订单业务类型枚举
 */
export enum OrderBusinessType {
  /** HP订单 */
  HP = 0,
  /** PF订单 */
  PF = 1,
}

/**
 * Tab 类型枚举
 */
export enum OrderTabType {
  /** 待指派 */
  ToBeAssigned = 'toBeAssigned',
  /** 配送中 */
  InDelivery = 'inDelivery',
  /** 已完成 */
  Completed = 'completed',
  /** 异常待处理 */
  AbnormalPending = 'abnormalPending',
}

/**
 * 待指派子状态枚举
 */
export enum ToBeAssignedSubStatus {
  /** 需人工 */
  Manual = 'manual',
  /** 智能派单中 */
  Intelligent = 'intelligent',
  /** 待确认 */
  Pending = 'pending',
  /** 挂起 */
  Suspended = 'suspended',
}

/**
 * 配送中子状态枚举
 */
export enum InDeliverySubStatus {
  /** 全部 */
  All = 'all',
  /** 撤单申请 */
  CancellationApplication = 'cancellationApplication',
  /** 取餐超时 */
  PickupTimeout = 'pickupTimeout',
  /** 出餐超时 */
  MealPrepTimeout = 'mealPrepTimeout',
  /** 超地区标准 */
  ExceedsRegionalStandard = 'exceedsRegionalStandard',
  /** 骑手考核超时 */
  RiderAssessmentTimeout = 'riderAssessmentTimeout',
  /** 骑手考核即将超时 */
  RiderAssessmentImminentTimeout = 'riderAssessmentImminentTimeout',
  /** 超60min */
  Exceeds60Min = 'exceeds60Min',
  /** 3mile内 40-60min */
  Within3Mile40To60Min = 'within3Mile40To60Min',
}
